function initializeHalloween(root = document) {
  root.querySelectorAll('[data-hw-compare]').forEach(compare => {
    if (compare.dataset.ready) return;
    compare.dataset.ready = 'true';
    const range = compare.querySelector('input');
    range.addEventListener('input', () => compare.style.setProperty('--reveal', range.value + '%'));
  });
  root.querySelectorAll('[data-hw-pack]').forEach(input => {
    if (input.dataset.ready) return;
    input.dataset.ready = 'true';
    input.addEventListener('change', () => {
      if (input.checked) input.closest('.hw-shop').querySelector('[data-hw-price]').textContent = input.dataset.total;
    });
  });
  root.querySelectorAll('[data-hw-variant]').forEach(select => {
    if (select.dataset.ready) return;
    select.dataset.ready = 'true';
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const section = select.closest('.hw-shop');
      section.querySelector('[data-hw-price]').textContent = option.dataset.price;
      const button = section.querySelector('[data-hw-buy]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.unavailableText : button.dataset.availableText;
    });
  });
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeHalloween());
else initializeHalloween();
document.addEventListener('shopify:section:load', event => initializeHalloween(event.target));

document.querySelectorAll('[data-hw-gallery]').forEach(gallery => {
 const track=gallery.querySelector('.hw-gallery-track');
 const slides=[...gallery.querySelectorAll('[data-hw-slide]')];
 const buttons=[...gallery.querySelectorAll('[data-hw-thumb]')];
 const activate=index=>buttons.forEach((button,n)=>button.setAttribute('aria-pressed',String(n===index)));
 buttons.forEach((button,index)=>button.addEventListener('click',()=>{track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});activate(index)}));
 track.addEventListener('scroll',()=>activate(Math.round(track.scrollLeft/track.clientWidth)),{passive:true});
});
